import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './dappNav.module.css';
import LoginButton from '../Buttons/LoginButton';

const HamburgerIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 12H21M3 6H21M3 18H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const CloseIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const DappNav = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className={styles.navbar}>
      <div className={styles.navContainer}>
        <div className={styles.navLeft}>
          <div className={styles.logo}>
            <Link to="/">
              <img src={require('../../../../assets/LogoWhite.png')} alt="RAYVO Logo" />
            </Link>
          </div>
        </div>
        <div className={styles.navRight}>
          <div className={`${styles.overlay} ${isMenuOpen ? styles.open : ''}`} onClick={closeMenu}></div>
          <div className={`${styles.mobileNav} ${isMenuOpen ? styles.open : ''}`}>
            <ul className={styles.navMenu}>
              <li><a href="/" className={styles.navLink}>Purchase</a></li>
              <li><a href="/earn" className={styles.navLink}>Dashboard</a></li>
            </ul> 
          </div>
          <LoginButton />
          <button className={styles.hamburger} onClick={toggleMenu}>
            {isMenuOpen ? <CloseIcon /> : <HamburgerIcon />}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default DappNav;